// helpers/LocationChange.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearMessage } from '../actions/message';

const LocationChange = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clearMessage());
    }, [location, dispatch]);

    return null; // Questo componente non renderizza nulla
};

export default LocationChange;